var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconContactUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.25C3 9.92578 4.85938 8 7.25 8H32.75C35.0742 8 37 9.92578 37 12.25V29.25C37 31.6406 35.0742 33.5 32.75 33.5H7.25C4.85938 33.5 3 31.6406 3 29.25V12.25ZM5.125 12.25V14.9062L18.0742 24.4688C19.2031 25.2656 20.7305 25.2656 21.8594 24.4688L34.875 14.9062V12.25C34.875 11.1211 33.8789 10.125 32.75 10.125H7.18359C6.05469 10.125 5.05859 11.1211 5.05859 12.25H5.125ZM5.125 17.5625V29.25C5.125 30.4453 6.05469 31.375 7.25 31.375H32.75C33.8789 31.375 34.875 30.4453 34.875 29.25V17.5625L23.1211 26.1953C21.2617 27.5234 18.6719 27.5234 16.8125 26.1953L5.125 17.5625Z",
    fill: "#8DA5BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContactUs);
export default __webpack_public_path__ + "static/media/icon-contact-us.1121d377.svg";
export { ForwardRef as ReactComponent };